import { Controller } from '@hotwired/stimulus';
import { parseDiceNotation } from '../../lib/rolls/notation';

export default class extends Controller {
  static targets = ['error', 'form', 'input'];

  submitEnd() {}

  availabilityChanged({ detail: { available } }) {
    const visibility = this.element.querySelector('input[type="checkbox"][name="roll[visibility]"]');
    if (!visibility) return;
    visibility.disabled = !available;
    if (!available) visibility.checked = false;
  }

  validate(event) {
    try {
      const notation = parseDiceNotation(this.inputTarget.value);
      this.inputTarget.value = notation.normalized;
      this.inputTarget.classList.remove('is-invalid');
      if (this.hasErrorTarget) {
        this.errorTarget.classList.remove('d-block');
        this.errorTarget.textContent = '';
      }
    } catch (error) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.inputTarget.classList.add('is-invalid');
      const errorElement = this.#errorElement();
      errorElement.textContent = error.message;
      errorElement.classList.add('d-block');
      this.inputTarget.focus();
    }
  }

  useRemembered(event) {
    event.preventDefault();
    this.inputTarget.value = event.currentTarget.dataset.dice;
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.formTarget.requestSubmit();
  }

  #errorElement() {
    if (this.hasErrorTarget) return this.errorTarget;

    const errorElement = document.createElement('div');
    errorElement.classList.add('invalid-feedback');
    errorElement.setAttribute('data-rolls--form-target', 'error');
    this.inputTarget.insertAdjacentElement('afterend', errorElement);
    return errorElement;
  }
}
